var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BlogItem',{attrs:{"blogList":_vm.blogList}}),_c('Pagination',{attrs:{"getBlogList":_vm.getBlogList,"totalPage":_vm.totalPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }